module.exports = __webpack_public_path__ + "static/img/best_picture_slider_1_1.4c2f4ea.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/best_picture_slider_1_1.jpg
// module id = 269
// module chunks = 0